<template>
    <a href="#" @click="toggle" class="lc-user-navigation user-navigation header__item header__item--link" :aria-expanded="isOpen">
        <avatar :user="currentUser" :show-tooltip="false" class="lc-avatar" />
        <p class="user-navigation__name">{{ currentUser.display_name }}</p>
        <icon type="chevron-bottom" color="gray" size="16" />

        <ul v-if="isOpen" class="dropdown-menu dropdown-menu--small dropdown-menu--right" :aria-expanded="isOpen">
            <li v-if="currentUser.is_administrator" class="dropdown-menu__item">
                <a :href="currentTenant.settings_url" class="dropdown-menu__link">Account settings</a>
            </li>
            <li class="dropdown-menu__item">
                <a :href="currentUser.settings_url" class="lc-open-profile dropdown-menu__link">Edit profile</a>
            </li>
            <li class="dropdown-menu__item">
                <a href="#" @click.prevent="$refs.logout.submit" class="lc-logout dropdown-menu__link dropdown-menu__link--danger logout__button">Logout</a>
            </li>
        </ul>

        <form ref="logout" action="/logout" method="post" class="logout">
            <input type="hidden" name="_token" :value="csrfToken">
            <input type="hidden" name="_method" value="DELETE">
        </form>
    </a>
</template>

<script>
/* global app */
import { mapState } from 'vuex'
import Toggleable from '../../mixins/toggle'
import currentTenantAware from '../../mixins/currentTenantAware'
import Avatar from '../Global/Avatar'
import Icon from '../Global/Icon'

export default {
    name: 'UserNavigation',

    mixins: [Toggleable, currentTenantAware],

    data () {
        return {
            // TODO: Move to state or somewhere better
            csrfToken: app.csrfToken
        }
    },

    computed: {
        ...mapState('users', {
            currentUser: 'current'
        })
    },

    components: {
        Avatar,
        Icon
    }
}
</script>
